// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.8.0",
  date: "2026-08-31T04:54:33.708Z",
  gitInfo: {
    dirty: false,
    raw: "284b001de",
    hash: "284b001de",
    distance: null,
    tag: null,
    semver: null,
    suffix: "284b001de",
    semverString: null
  }
};
/* tslint:enable */
